import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';
import Icon from '@/components/Icon';
import { useTheme } from '@/context/ThemeContext';
import useResponsiveness from '@/hooks/useResponsiveness';

function MessageBotAvatar({ agent }) {
  const { colors } = useTheme();
  const { isXS } = useResponsiveness();
  const [failedSource, setFailedSource] = useState(null);
  if (!agent?.id) return null;
  const size = isXS ? 24 : 30;
  const source = agent.avatarPath;
  return (
    <View
      accessible
      accessibilityRole="image"
      accessibilityLabel={agent.name || 'Bot'}
      style={[styles.avatar, { width: size, height: size, marginRight: isXS ? 8 : 12, backgroundColor: colors.solid_color_tertiary }]}
    >
      {source && failedSource !== source ? (
        <Image
          source={{ uri: source }}
          style={{ width: size, height: size, borderRadius: size / 2 }}
          contentFit="cover"
          accessible={false}
          onError={() => setFailedSource(source)}
        />
      ) : (
        <Icon name="robot" size={isXS ? 14 : 18} color={colors.text_color_tertiary} />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  avatar: {
    flexShrink: 0,
    borderRadius: 99,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
    overflow: 'hidden',
    marginTop: 2,
  },
});

export default React.memo(MessageBotAvatar);
